<template>
  <div
    id="toggleOpenFilterButton"
    class="filter__header"
    @click="filterClickHandler"
    :class="{'open': openFilter}"
  >
    <span class="filter__text labelStyleH">Filter</span>
  </div>
</template>

<script>
import  EventBus  from "../EventBus.js";
import { FILTER_CLICK_EVENT, FILTER_CLOSE_EVENT } from "../js/event";

export default {
  name: "table-filter-component",
  data() {
    return {
      isFilterOpen: false
    };
  },
  mounted() {
    EventBus.$on(FILTER_CLOSE_EVENT, () =>  {
      (this.isFilterOpen = false)
      });
  },
  beforeDestroy() {
    EventBus.$off(FILTER_CLOSE_EVENT);
  },
  computed: {
    openFilter() {
      return this.isFilterOpen;
    }
  },
  methods: {
    filterClickHandler() {
      this.isFilterOpen = !this.isFilterOpen;
      this.$emit(FILTER_CLICK_EVENT, this.isFilterOpen);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/hpConstant.scss";
@import "../styles/hpCommon.scss";

.filter__header {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url("../assets/images/icons/filter_open.png");
  background-repeat: no-repeat;
  background-position: 90% 50%;
  height: 50px;
  width: 20%;
  margin: 0;
  padding: 0 20px;
  cursor: pointer;
  color: $hpWhite;
  background-color: $hpLightBlue;
}

.filter__text {
  text-transform: none;
  line-height: 18px;
  font-size: 16px;
}

.filter__header.open {
  background-image: url("../assets/images/icons/filter_close.png");
  background-repeat: no-repeat;
  background-position: 90% 50%;
}
@media only screen and (max-width: 576px) {
.filter__header {
  background-position: 98% 48%;
  margin-right: 1%;
  padding: 0 20px;
}

.filter__header.open {
  background-position: 98% 48%;
}

.filter__text {
  margin-left: -15px;
}

}
</style>